import { render, staticRenderFns } from "./ProgramDashboardV2.vue?vue&type=template&id=d942ede2&scoped=true"
import script from "./ProgramDashboardV2.vue?vue&type=script&lang=js"
export * from "./ProgramDashboardV2.vue?vue&type=script&lang=js"
import style0 from "./ProgramDashboardV2.vue?vue&type=style&index=0&id=d942ede2&prod&scoped=true&lang=css"
import style1 from "./ProgramDashboardV2.vue?vue&type=style&index=1&id=d942ede2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d942ede2",
  null
  
)

export default component.exports